// extracted by mini-css-extract-plugin
export default {"senhaDescricao":"styles_senhaDescricao__4FRjG","formulario":"styles_formulario__lP9eO"};